import './FlagImageByUrl.scss';

interface IFlagImageByUrlProps {
  url?: string | null;
  className?: string;
}

/**
 * Muestra una bandera como imagen de fondo a partir de una URL.
 * Reutilizable para banderas de país o empresa; las dimensiones y estilo se definen
 * en el padre mediante className (p. ej. con el mixin flagGeneralStyles).
 */
const FlagImageByUrl = ({ url, className = '' }: IFlagImageByUrlProps) => {
  if (!url) return null;

  return (
    <span
      className={`flagImageByUrl ${className}`.trim()}
      style={{ backgroundImage: `url("${url}")` }}
      aria-hidden
    />
  );
};

export default FlagImageByUrl;
